import { useEffect } from 'react';
import { useNavigate, Link, Outlet, useLocation } from 'react-router-dom';
import { LayoutDashboard, FileText, Briefcase, MessageSquare, Mail, LogOut } from 'lucide-react';

const NAV_ITEMS = [
  { to: '/admin/dashboard', label: 'Dashboard', icon: LayoutDashboard },
  { to: '/admin/blog', label: 'Blog', icon: FileText },
  { to: '/admin/cases', label: 'Casos de Estudio', icon: Briefcase },
  { to: '/admin/testimonials', label: 'Testimonios', icon: MessageSquare },
  { to: '/admin/contacts', label: 'Contactos', icon: Mail },
];

const AdminLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const token = localStorage.getItem('adminToken');

  useEffect(() => {
    if (!token) navigate('/admin');
  }, [token, navigate]);

  if (!token) return null;

  const logout = () => {
    localStorage.removeItem('adminToken');
    navigate('/admin');
  };

  return (
    <div className="min-h-screen bg-[#0F1C2E] flex" data-testid="admin-layout">
      {/* Sidebar */}
      <aside className="w-60 bg-[#1A2639] border-r border-white/8 flex flex-col flex-shrink-0">
        <div className="p-5 border-b border-white/8">
          <div className="flex items-center gap-2">
            <div className="w-6 h-6 bg-[#7D468C] flex-shrink-0" style={{ transform: 'rotate(45deg)' }} />
            <span className="font-poppins font-bold text-white text-sm">MIKEL MEDIA</span>
          </div>
          <p className="text-white/35 text-xs mt-1 font-source-sans">Admin Panel</p>
        </div>

        <nav className="flex-1 p-3 space-y-0.5">
          {NAV_ITEMS.map(item => {
            const Icon = item.icon;
            const active = location.pathname === item.to;
            return (
              <Link
                key={item.to}
                to={item.to}
                data-testid={`admin-nav-${item.to.split('/').pop()}`}
                className={`flex items-center gap-3 px-3 py-2.5 text-sm font-source-sans transition-colors ${
                  active
                    ? 'bg-[#7D468C]/20 text-[#7D468C] border-l-2 border-[#7D468C]'
                    : 'text-white/55 hover:text-white hover:bg-white/5 border-l-2 border-transparent'
                }`}
              >
                <Icon size={15} />
                {item.label}
              </Link>
            );
          })}
        </nav>

        <div className="p-3 border-t border-white/8">
          <button
            onClick={logout}
            data-testid="admin-logout"
            className="flex items-center gap-3 px-3 py-2.5 text-sm text-white/45 hover:text-red-400 transition-colors w-full font-source-sans"
          >
            <LogOut size={15} />
            Cerrar Sesión
          </button>
        </div>
      </aside>

      {/* Main content */}
      <main className="flex-1 overflow-auto bg-[#0F1C2E]">
        <Outlet />
      </main>
    </div>
  );
};

export default AdminLayout;
